import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

import type { RootState } from '@/app/store';

export interface DashboardState {
  title: string;
}

const initialState: DashboardState = {
  title: '',
};

export const dashboardSlice = createSlice({
  name: 'dashboard',
  initialState,
  reducers: {
    setTitle: (state: DashboardState, action: PayloadAction<string>) => {
      state.title = action.payload;
    },
  },
});

export const { setTitle } = dashboardSlice.actions;

export const selectTitle = (state: RootState): string => state.dashboard.title;

export default dashboardSlice.reducer;
